/* =====================================================
   ARVELLARA NAVY — JavaScript (matches index.html exactly)
   ===================================================== */

(function () {
  'use strict';

  function boot() {
    /* ---------- Header scroll state + scroll-to-top ---------- */
    var header = document.getElementById('arv-site-header');
    var scrollTopBtn = document.getElementById('arv-scroll-top');
    if (header || scrollTopBtn) {
      window.addEventListener('scroll', function () {
        var y = window.scrollY;
        if (header) header.classList.toggle('is-scrolled', y > 40);
        if (scrollTopBtn) scrollTopBtn.classList.toggle('is-show', y > 600);
      }, { passive: true });
    }
    if (scrollTopBtn) {
      scrollTopBtn.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    /* ---------- Mobile nav ---------- */
    var menuToggle = document.getElementById('arv-menu-toggle');
    var siteNav = document.getElementById('arv-site-nav');
    var overlay = document.getElementById('arv-menu-overlay');
    function closeMenu() {
      if (siteNav) siteNav.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-show');
    }
    if (menuToggle && siteNav && overlay) {
      menuToggle.addEventListener('click', function () {
        siteNav.classList.toggle('is-open');
        overlay.classList.toggle('is-show');
      });
      overlay.addEventListener('click', closeMenu);
      siteNav.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', closeMenu);
      });
    }

    /* ---------- Scroll reveal ---------- */
    var revealEls = document.querySelectorAll('.arv-reveal');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });
      revealEls.forEach(function (el) { io.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('is-visible'); });
    }

    /* ---------- Animated counters ---------- */
    var counters = document.querySelectorAll('.arv-stat-num');
    if (counters.length) {
      var counterIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var el = entry.target;
            var target = parseInt(el.dataset.count, 10) || 0;
            var suffix = el.dataset.suffix || '';
            var duration = 1400;
            var start = null;
            function tick(now) {
              if (start === null) start = now;
              var progress = Math.min((now - start) / duration, 1);
              var eased = 1 - Math.pow(1 - progress, 3);
              el.textContent = Math.round(eased * target) + suffix;
              if (progress < 1) requestAnimationFrame(tick);
            }
            requestAnimationFrame(tick);
            counterIO.unobserve(el);
          }
        });
      }, { threshold: 0.4 });
      counters.forEach(function (el) { counterIO.observe(el); });
    }

    /* ---------- Marquee seamless duplication ---------- */
    var marquee = document.getElementById('arv-marquee');
    if (marquee && !marquee.dataset.cloned) {
      marquee.innerHTML += marquee.innerHTML;
      marquee.dataset.cloned = 'true';
    }

    /* ---------- Hero parallax blobs ---------- */
    var hero = document.querySelector('.arv-hero');
    if (hero) {
      var blobs = hero.querySelectorAll('.arv-blob');
      hero.addEventListener('mousemove', function (e) {
        var rect = hero.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        blobs.forEach(function (b) {
          var depth = parseFloat(b.dataset.depth || 0.05);
          b.style.transform = 'translate(' + (x * 100 * depth) + 'px, ' + (y * 100 * depth) + 'px)';
        });
      });
    }

    /* ---------- Testimonial carousel ---------- */
    var slides = document.querySelectorAll('.arv-slide');
    var dotsWrap = document.getElementById('arv-dots');
    if (slides.length && dotsWrap) {
      var current = 0;
      slides.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.classList.add('arv-dot');
        dot.setAttribute('aria-label', 'Show testimonial ' + (i + 1));
        if (i === 0) dot.classList.add('is-active');
        dot.addEventListener('click', function () { goToSlide(i); });
        dotsWrap.appendChild(dot);
      });
      var dots = dotsWrap.querySelectorAll('.arv-dot');
      function goToSlide(i) {
        slides[current].classList.remove('is-active');
        dots[current].classList.remove('is-active');
        current = i;
        slides[current].classList.add('is-active');
        dots[current].classList.add('is-active');
      }
      setInterval(function () {
        goToSlide((current + 1) % slides.length);
      }, 5000);
    }

    /* ---------- FAQ accordion ---------- */
    document.querySelectorAll('.arv-faq-item').forEach(function (item) {
      var q = item.querySelector('.arv-faq-q');
      if (!q) return;
      q.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        var list = item.closest('.arv-faq-list') || document;
        list.querySelectorAll('.arv-faq-item').forEach(function (i) {
          i.classList.remove('is-open');
        });
        if (!isOpen) item.classList.add('is-open');
      });
    });

    /* ---------- Newsletter inline confirmation ---------- */
    document.querySelectorAll('.arv-newsletter-form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('button');
        if (btn) btn.textContent = 'Subscribed ✓';
      });
    });

    /* ---------- Smooth anchor scroll offset ---------- */
    document.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var targetId = this.getAttribute('href');
        if (targetId.length > 1) {
          var target;
          try { target = document.querySelector(targetId); } catch (err) { target = null; }
          if (target) {
            e.preventDefault();
            var offset = target.getBoundingClientRect().top + window.scrollY - 80;
            window.scrollTo({ top: offset, behavior: 'smooth' });
          }
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
